export default [
  'clickSend',
  'clickSmsIcon',
  'clickSmsNotification',
  'openSmsFromQueryParam'
]
